
import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'newsletter-signup',
  components: ServiceContainer().getComponents(),
})
export default class extends Vue {
  $refs!: {'mailingListForm': HTMLFormElement}

  @Prop({default: true}) private readonly hideFormOnSuccess: boolean;
  @Prop({default: 'subscribe_home'}) private readonly source: string;
  @Prop({default: 'MAIL_SUBSCRIBE'}) private readonly type: string;
  @Prop({default: 'Vul hier je e-mailadres in..'}) private readonly placeholder: string;

  private showSuccess: boolean = false;
  private userMail: string = '';

  private get showSubscribeForm(): boolean {
    return this.hideFormOnSuccess ? !this.showSuccess : true;
  }

  private addSubscriber(): void {
    const form = this.$refs.mailingListForm;
    const data = {_options: {anonymous: true}};
    const fields = form.elements;

    for (let i = 0, f = fields[0]; i < fields.length; i += 1, f = fields[i]) {
      if (f['name']) {
        data[f['name']] = f['value'];
      }
    }

    window['cstbr'].push(data);

    this.showSuccess = true;
  }

  private created(): void {
    if ( ! window['cstbr']) {
      window['cstbr'] = [];
    }
  }
}
